// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__arR_u","delete":"styles_delete__1iC66","update":"styles_update__2jHB3","add":"styles_add__2gS7o"};